import { generateClient } from "aws-amplify/api";
import type { GraphqlSubscriptionResult } from "@aws-amplify/api-graphql";
import type { Subscription } from "rxjs";
import * as subscriptions from "./schema/subscriptions";

export type GraphQLSubscription = GraphqlSubscriptionResult<
  Record<string, unknown>
>;
export type { Subscription as GraphQLObservableSubscription };

const client = generateClient();

export const executeQuery = async (
  query: string,
  variables?: Record<string, unknown>,
) => {
  return await client.graphql({
    query,
    variables: { ...variables },
  });
};

export const executeMutation = async (
  mutation: string,
  variables?: Record<string, unknown>,
) => {
  return await client.graphql({
    query: mutation,
    variables: { ...variables },
  });
};

export const subOnUpdateClosureMessages = (
  instanceId: string,
): GraphQLSubscription => {
  return client.graphql({
    query: subscriptions.onProcessedClosureMessage,
    variables: { instanceId },
  }) as GraphQLSubscription;
};
export const subOnUpdateTemporaryMessages = (
  instanceId: string,
): GraphQLSubscription => {
  return client.graphql({
    query: subscriptions.onProcessedTemporaryMessage,
    variables: { instanceId },
  }) as GraphQLSubscription;
};

export const subOnProcessedMedia = (
  instanceId: string,
): GraphQLSubscription => {
  return client.graphql({
    query: subscriptions.onProcessedMedia,
    variables: { instanceId },
  }) as GraphQLSubscription;
};

/**
 * Stop Contact subscription
 * @param  {string} instanceId     current instaceId
 * @return {Observable}            subscription
 */
export const subOnProcessedContactEvent = (
  instanceId: string,
): GraphQLSubscription => {
  return client.graphql({
    query: subscriptions.onProcessedContactEvent,
    variables: { instanceId },
  }) as GraphQLSubscription;
};
